export default "__VITE_ASSET__Cemhs7V___"